export const hasTransitionToStatus = (status, transitions) => {
  return transitions.some((t) => t.toStatusId === status.id);
};

export const hasTransitionToSubStatus = (subStatus, transitions) => {
  return transitions.some(
    (t) =>
      t.toStatusId === subStatus.statusId &&
      (t.toSubStatusId === subStatus.id || t.toSubStatusId === null),
  );
};

export const hasTransitionToOtherStatus = (
  subStatus,
  otherStatus,
  transitions,
) => {
  return transitions.some(
    (t) =>
      t.toStatusId === subStatus?.statusId &&
      (t.toSubStatusId === null || t.toSubStatusId === subStatus?.id) &&
      (t.toOtherStatusId === null || t.toOtherStatusId === otherStatus?.id),
  );
};

export const shouldShowDisabledStatusAlert = (
  currentSubStatus,
  transitionDataStatusKey,
  currentStatusKey,
) => {
  return !!(
    currentSubStatus &&
    !currentSubStatus.isActive &&
    transitionDataStatusKey === currentStatusKey
  );
};

export const getAvailableStatusNames = (
  transitions,
  statusesById = {},
  subStatusesById = {},
) => {
  return transitions
    .map((t) => {
      const status = statusesById[t.toStatusId];
      const subStatus = subStatusesById[t.toSubStatusId];

      if (!status) {
        return null;
      }

      return `${status.name} - ${subStatus?.name ?? "Any"}`;
    })
    .filter(Boolean);
};

const SOURCED_HIRE_TYPES = ["source_hired", "re_hire_sourced"];

export const getInitialStatusOptions = (hireType) =>
  SOURCED_HIRE_TYPES.includes(hireType)
    ? [{ label: "Prospect - Sourced", value: "Prospect-Sourced" }]
    : [
        {
          label: "Candidates - Needs Review",
          value: "Candidates-Needs Review",
        },
      ];
